module.exports = __webpack_public_path__ + "assets/26c4ed9aa032104b7ecdb51348bc304c.mp4";